"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.formatDisplayLocalDate = exports.formatISOLocalDate = void 0;

var _format = _interopRequireDefault(require("date-fns/format"));

var _dateUtil = require("./date-util");

var formatISOLocalDate = function formatISOLocalDate(v) {
  return v ? (0, _format["default"])(v, _dateUtil.DEFAULT_FORMAT) : '';
};

exports.formatISOLocalDate = formatISOLocalDate;

var formatDisplayLocalDate = function formatDisplayLocalDate(v) {
  return v ? (0, _format["default"])(v, _dateUtil.DISPLAY_FORMAT) : '';
};

exports.formatDisplayLocalDate = formatDisplayLocalDate;